import styled from "styled-components/macro";
import { Button } from "@mui/material";
import { ONE_DAY_OF_MS } from "../../utils/timeUtils";

const TooBigStyles = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    margin: 1em 0;
  }
`;

export const TooBigToLoadIndicator = ({
  name,
  handleTryToLoad,
  maxFocusRangeDuration,
}) => (
  <TooBigStyles>
    <p>
      Focus range is too long to load {name}
      {maxFocusRangeDuration
        ? ` (maximum is ${(maxFocusRangeDuration / ONE_DAY_OF_MS).toFixed(
            0
          )} days)`
        : ""}
      .
    </p>

    <Button variant="outlined" onClick={handleTryToLoad}>
      Try to load it anyway
    </Button>
  </TooBigStyles>
);
